// extracted by mini-css-extract-plugin
export default {"navigation":"e6EySzWeLTQvYhcMWF3P"};